import Flag from "react-world-flags";

const PlayerStats = ({ stats, countryCode }) => {
  return (
    <>
      <div className="mt-10">
        <dl className="grid grid-cols-2 gap-x-4 gap-y-8">
          {stats.map((stat) => (
            <div key={stat.label} className="border-t-2 border-gray-100 pt-6">
              <dt className="text-base font-medium text-gray-500">
                {stat.label}
              </dt>
              <dd className="text-xl sm:text-2xl font-extrabold tracking-tight text-gray-900">
                {stat.label === "Country" ? (
                  <>
                    {" "}
                    <div className="inline-flex">
                      <Flag
                        code={countryCode}
                        alt="Player Country logo"
                        height="30"
                        width="30"
                        fallback={<span>--</span>}
                      />
                      <p className="ml-2">{stat.value}</p>
                    </div>
                  </>
                ) : (
                  stat.value
                )}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </>
  );
};

export default PlayerStats;
